export const formations = [
  {
    _id: "1",
    title: "Formation en Marketing Digital",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec tellus nulla, interdum nec augue vitae, tincidunt blandit ligula. In hac habitasse platea dictumst.",
  },
  {
    _id: "2",
    title: "Formation en UX/UI Design",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec tellus nulla, interdum nec augue vitae, tincidunt blandit ligula. In hac habitasse platea dictumst.",
  },
  {
    _id: "3",
    title: "Formation en Design graphique",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec tellus nulla, interdum nec augue vitae, tincidunt blandit ligula. In hac habitasse platea dictumst.",
  },
  {
    _id: "4",
    title: "Formation en Power BI",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec tellus nulla, interdum nec augue vitae, tincidunt blandit ligula. In hac habitasse platea dictumst.",
  },
];
